import React, { useState, useContext, useRef } from 'react';
import { Formik } from "formik";
import { Input } from "formik-antd";
import MultiStepFormContext from "./MultiStepFormContext";
import './JobOnboarding.css';
import DummyUploadImage from "../../assets/images/upload-image4.svg";

const UploadMedia = () =>
{

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSuccess, setIsLoadingSuccess] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const { uploadedImages, setUploadedImages, next, prev, isPublish, setIsPublish } = useContext(MultiStepFormContext);
  const fileInputRefs = useRef();

  const handleFileChange = (file) =>
  {
    if (file)
    {
      const newImageUrl = URL.createObjectURL(file);
      const newUploadedImages = [...uploadedImages];

      const emptyIndex = newUploadedImages.findIndex(img => img === null);

      if (emptyIndex !== -1)
      {
        newUploadedImages[emptyIndex] = { file, url: newImageUrl };
        setUploadedImages(newUploadedImages);
      } else
      {
        alert("You can only upload up to four images.");
      }
    }
  };

  const handleDragOver = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragEnter = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0)
    {
      const file = e.dataTransfer.files[0];
      handleFileChange(file);
      e.dataTransfer.clearData();
    }
  };

  const handleFileSelectClick = () =>
  {
    if (fileInputRefs.current)
    {
      fileInputRefs.current.click();
    }
  };

  const handleRemoveFile = (image, index) =>
  {
    const updatedImages = [...uploadedImages];
    updatedImages[index] = null;
    const filledImages = updatedImages.filter(img => img !== null);
    const newImages = [...filledImages, ...Array(4 - filledImages.length).fill(null)];
    setUploadedImages(newImages);
  };

  return (
    <Formik
      initialValues={uploadedImages}
      onSubmit={(values) =>
      {
        setUploadedImages(values);
        setIsLoading(true);
        // setIsPopup(true);
        next(isPublish);
        setTimeout(() =>
        {
          setIsLoading(false);
        }, 2000);
      }}
    >
      {({ handleSubmit, errors }) =>
      {
        return (
          <div>
            <div className="form-main">
              <div className={"form-row"}>
                <div className="form-group">
                  <label>
                    Upload images of the job to help businesses provide quotes
                  </label>
                  <div className="upload_image d-flex justify-content-between w-100">
                    <div className='upload_image-drag-before'>
                      <div
                        className={`upload_image-drag ${isDragging ? 'dragging' : ''}`}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                      >
                        <p className='upload_image-drag-p'>
                          Drag and Drop file here
                        </p>
                      </div>
                    </div>
                    <div className='upload_image-btn' onClick={handleFileSelectClick}>
                      <p className='upload_image-btn-p' >
                        Browse Files</p>
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRefs}
                      style={{ display: 'none' }}
                      onChange={(e) => handleFileChange(e.target.files[0])}
                    />
                  </div>
                </div>
              </div>
              <div className="image_section">
                {uploadedImages.map((image, index) => (
                  <div key={index} className="image_slot">
                    <img src={image?.url || DummyUploadImage} alt={`Uploaded ${index}`} className="image_box" />
                    {image?.url ? (<svg className='close-icon' xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="16" height="16" onClick={() => handleRemoveFile(image, index)}>
                      <path d="M18,6h0a1,1,0,0,0-1.414,0L12,10.586,7.414,6A1,1,0,0,0,6,6H6A1,1,0,0,0,6,7.414L10.586,12,6,16.586A1,1,0,0,0,6,18H6a1,1,0,0,0,1.414,0L12,13.414,16.586,18A1,1,0,0,0,18,18h0a1,1,0,0,0,0-1.414L13.414,12,18,7.414A1,1,0,0,0,18,6Z" />
                    </svg>) : null}
                  </div>
                ))}
              </div>
            </div>

            <div className="button_section onboarding-form-button">

              <button type="button" onClick={prev}>Back</button>
              <button onClick={() =>
              {
                setIsPublish(false);
                if (isPublish)
                {
                  setIsPublish(false);
                } else
                {
                  handleSubmit();
                }
              }} className="button-blue" type='button'>Save Draft</button>
              <button type='button' onClick={handleSubmit} isLoadingSuccess={isLoadingSuccess} isLoading={isLoading}>Save & Publish Job</button>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};
export default UploadMedia;
